import { routeConstants } from "constants/routeConstants";
import { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Dashboard = memo(() => {
    const navigateTo = useNavigate();

    useEffect(() => {
        navigateTo(routeConstants.profile.root);
    }, [navigateTo]);

    return <div>Dashboard.component</div>;
});
